export class FilePreview {
  constructor(public columns: string[], public rows: object[]) {}
}
